export default __webpack_public_path__ + "static/07_Horse-38597be378c251b1cb67b9625b5e7bb2.png";